import React from 'react';
import './PasswordResetConfirmation.css';

const PasswordResetConfirmation: React.FC = () => {
  const handleBackToLogin = () => {
    window.location.href = '/';
  };

  const handleGoToDashboard = () => {
    // Redirect to user dashboard
    window.location.href = '/dashboard';
  };

  return (
    <div className="password-reset-confirmation-container">
      <div className="password-reset-confirmation-card">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" fill="#10B981"/>
            <path d="M25 40L35 50L55 30" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="success-title">Password Reset Successful!</h1>
        
        <p className="success-message">
          Great! Your password has been successfully updated. You can now use your new password to access your Sportagram account.
        </p>
        
        <div className="success-details">
          <div className="detail-item">
            <div className="detail-icon">🔒</div>
            <div className="detail-content">
              <strong>Secure Password</strong>
              <span>Your new password meets all security requirements</span>
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-icon">✓</div>
            <div className="detail-content">
              <strong>Account Protected</strong>
              <span>Your account is now secured with the new password</span>
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-icon">🚀</div>
            <div className="detail-content">
              <strong>Ready to Go</strong>
              <span>You can now access all Sportagram features</span>
            </div>
          </div>
        </div>
        
        <div className="security-tip">
          <div className="tip-icon">💡</div>
          <div className="tip-content">
            <strong>Security Tip:</strong> Keep your password safe and don't share it with anyone. 
            Consider using a password manager for better security.
          </div>
        </div>
        
        <div className="action-buttons">
          <button 
            className="primary-button"
            onClick={handleGoToDashboard}
          >
            Go to Dashboard
          </button>
          
          <button 
            className="secondary-button"
            onClick={handleBackToLogin}
          >
            Back to Login
          </button>
        </div>
        
        <div className="additional-info">
          <p>
            If you didn't request this password change, please 
            <a href="mailto:security@sportagram.com" className="security-link"> contact our security team</a> immediately.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetConfirmation;